// extracted by mini-css-extract-plugin
export default {"container":"OKnLq","placeInfoContainer":"_83s9D","ticketInfoContainer":"VF-TR","ticketName":"QfIrU"};